type ErrorProps = {
    error?: string | string[];
}

export const Error = ({error}: ErrorProps) => {
    return error && (
        <div className="text-red-500 text-sm">
            {Array.isArray(error) ? (
                error.map((err, index) => (
                    <p key={index}>{err}</p>
                ))
            ) : (
                <>{ error }</>
            )}
        </div>
    )
}
